import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { SivaReportingService } from 'src/api/v2';
import { SIVA_ADMIN_ESA_KEY } from 'src/constants/hook-keys';
import { useAuth } from 'src/features/authorization';

export const useAdminEsaOverview = (year: number) => {
  const [sivaReportingService] = useState(() => new SivaReportingService());
  const { checkAccess } = useAuth();
  const { read } = checkAccess('SivaAdmin');

  const adminEsaData = useQuery({
    queryKey: [SIVA_ADMIN_ESA_KEY, year],
    queryFn: () => sivaReportingService.listInnovationFunds(year),
    enabled: read,
  });

  return {
    adminEsaData: adminEsaData.data || [],
  };
};
